var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBed = function SvgBed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 16.85V19.25V16.85ZM23.7992 16.85V19.25V16.85Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5992 9.65V3.05C22.5992 2.57261 22.4096 2.11477 22.072 1.77721C21.7344 1.43964 21.2766 1.25 20.7992 1.25H5.19922C4.72183 1.25 4.26399 1.43964 3.92643 1.77721C3.58886 2.11477 3.39922 2.57261 3.39922 3.05V9.65M2.19922 16.85V19.25M23.7992 16.85V19.25",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 6.6499H7C6.52261 6.6499 6.06477 6.83954 5.72721 7.17711C5.38964 7.51468 5.2 7.97251 5.2 8.4499V9.6499H12.4V8.4499C12.4 7.97251 12.2104 7.51468 11.8728 7.17711C11.5352 6.83954 11.0774 6.6499 10.6 6.6499ZM19 6.6499H15.4C14.9226 6.6499 14.4648 6.83954 14.1272 7.17711C13.7896 7.51468 13.6 7.97251 13.6 8.4499V9.6499H20.8V8.4499C20.8 7.97251 20.6104 7.51468 20.2728 7.17711C19.9352 6.83954 19.4774 6.6499 19 6.6499ZM1 11.4499C1 10.9725 1.18964 10.5147 1.52721 10.1771C1.86477 9.83954 2.32261 9.6499 2.8 9.6499H23.2C23.6774 9.6499 24.1352 9.83954 24.4728 10.1771C24.8104 10.5147 25 10.9725 25 11.4499V16.8499H1V11.4499Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bed.541d6354.svg";
export { ForwardRef as ReactComponent };